import Vue from "vue";
import VueRouter from "vue-router";

// Single Pages
import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";
import SignUp from "../views/SignUp.vue";

import Profile from "../views/Profile.vue";
import BookingCalendar from "../views/BookingCalendar.vue";
import Booking from "../views/Booking.vue";
import OfferBooking from "../views/OfferBooking.vue";

// Settings
import SettingsOverview from "../views/settings/Overview.vue";
import SettingsUsers from "../views/settings/Users.vue";
import SettingsRentObjectTypes from "../views/settings/RentObjectTypes.vue";
import SettingsFeatureTags from "../views/settings/FeatureTags.vue";
import SettingsFeatureTagsAdminSort from "../views/settings/FeatureTagsAdminSort.vue";
import SettingsFeatureTagsWebsiteSort from "../views/settings/FeatureTagsWebsiteSort.vue";
import SettingsBookingExtras from "../views/settings/BookingExtras.vue";
import SettingsHolidays from "../views/settings/Holidays.vue";
import SettingsCommissions from "../views/settings/Commission.vue";
import SettingsEmailTemplates from "../views/settings/EmailTemplates.vue";
import SettingsDocumentContents from "../views/settings/DocumentContents.vue";
import SettingsDocumentContent from "../views/settings/DocumentContent.vue";
import SettingsChannelManager from "../views/settings/ChannelManager.vue";
import SettingsBusinessLogic from "../views/settings/BusinessLogic.vue";

// Lists
import ListsOverview from "../views/lists/Overview.vue";
import ListsArrivals from "../views/lists/Arrivals.vue";
import ListsCleaners from "../views/lists/Cleaners.vue";
import ListsDepartures from "../views/lists/Departures.vue";
import ListsBookings from "../views/lists/Bookings.vue";
import ListsInvoices from "../views/lists/Invoices.vue";
import ListsCleanersHeatmap from "../views/lists/CleanersHeatmap.vue";

// Statistics
import StatisticsOverview from "../views/statistics/Overview.vue";
import StatisticsOwners from "../views/statistics/Owners.vue";
import StatisticsRentObjects from "../views/statistics/RentObjects.vue";
import StatisticsItemSummary from "../views/statistics/ItemSummary.vue";
import StatisticsRevenueSummary from "../views/statistics/RevenueSummary.vue";
import StatisticsCustomerAnalysis from "../views/statistics/CustomerAnalysis.vue";
import UtilizationTable from "../views/statistics/UtilizationTable.vue";

// Finances
import FinancesOverview from "../views/finances/Overview.vue";
import FinancesOwnerSettlements from "../views/finances/OwnerSettlements.vue";
import CreateFinancesInvoices from "../views/finances/CreateFinancesInvoices.vue";
import FinancesInvoices from "../views/finances/FinancesInvoices.vue";

// CMS
import CMSOverview from "../views/cms/Overview.vue";
import CMSPromotions from "../views/cms/Promotions.vue";
import CMSPromotion from "../views/cms/Promotion.vue";
import CMSDailyTips from "../views/cms/DailyTips.vue";
import CMSBlocks from "../views/cms/Blocks.vue";
import CMSBlock from "../views/cms/Block.vue";
import CMSBlockModels from "../views/cms/BlockModels.vue";
import CMSBlockModel from "../views/cms/BlockModel.vue";
import CMSMedias from "../views/cms/Medias.vue";

// Data
import DataOverview from "../views/data/Overview.vue";
import DataRentObjectsAdminSort from "../views/data/RentObjectsAdminSort.vue";
import DataRentObjectChannels from "../views/data/RentObjectChannels.vue";
import DataRentObjects from "../views/data/RentObjects.vue";
import DataRentObject from "../views/data/RentObject.vue";
import DataCustomers from "../views/data/Customers.vue";
import DataCustomer from "../views/data/Customer.vue";
import DataOwners from "../views/data/Owners.vue";
import DataOwner from "../views/data/Owner.vue";
import DataCleaners from "../views/data/Cleaners.vue";
import DataCleaner from "../views/data/Cleaner.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp
  },
  {
    path: "/bookingcalendar",
    name: "BookingCalendar",
    component: BookingCalendar
  },
  {
    path: "/booking",
    name: "NewBooking",
    component: Booking
  },
  {
    path: "/booking/:id",
    name: "Booking",
    props: true,
    component: Booking
  },
  {
    path: "/offer-booking",
    name: "OfferBooking",
    component: OfferBooking
  },
  // Settings
  {
    path: "/settings",
    name: "SettingsOverview",
    component: SettingsOverview
  },
  {
    path: "/settings/users",
    name: "SettingsUsers",
    component: SettingsUsers
  },
  {
    path: "/settings/rent-object-types",
    name: "SettingsRentObjectTypes",
    component: SettingsRentObjectTypes
  },
  {
    path: "/settings/feature-tags",
    name: "SettingsFeatureTags",
    component: SettingsFeatureTags
  },
  {
    path: "/settings/feature-tags/admin-sort",
    name: "SettingsFeatureTagsAdminSort",
    component: SettingsFeatureTagsAdminSort
  },
  {
    path: "/settings/feature-tags/website-sort",
    name: "SettingsFeatureTagsWebsiteSort",
    component: SettingsFeatureTagsWebsiteSort
  },
  {
    path: "/settings/booking-extras",
    name: "SettingsBookingExtras",
    component: SettingsBookingExtras
  },
  {
    path: "/settings/holidays",
    name: "SettingsHolidays",
    component: SettingsHolidays
  },
  {
    path: "/settings/commission",
    name: "SettingsCommissions",
    component: SettingsCommissions
  },
  {
    path: "/settings/email-templates",
    name: "SettingsEmailTemplates",
    component: SettingsEmailTemplates
  },
  // Document Templates
  {
    path: "/settings/document-contents",
    name: "SettingsDocumentContents",
    component: SettingsDocumentContents
  },
  {
    path: "/settings/document-contents/new/:pdfType",
    props: true,
    name: "SettingsDocumentContentsNew",
    component: SettingsDocumentContent
  },
  {
    path: "/settings/document-contents/edit/:id",
    name: "SettingsDocumentContentsEdit",
    props: true,
    component: SettingsDocumentContent
  },
  // -------------------
  {
    path: "/settings/channel-manager",
    name: "SettingsChannelManager",
    component: SettingsChannelManager
  },
  {
    path: "/settings/business-logic",
    name: "SettingsBusinessLogic",
    component: SettingsBusinessLogic
  },
  // Statistics
  {
    path: "/statistics",
    name: "StatisticsOverview",
    component: StatisticsOverview
  },
  {
    path: "/statistics/owners",
    name: "StatisticsOwners",
    component: StatisticsOwners
  },
  {
    path: "/statistics/rent-objects",
    name: "StatisticsRentObjects",
    component: StatisticsRentObjects
  },
  {
    path: "/statistics/items-summary",
    name: "StatisticsItemSummary",
    component: StatisticsItemSummary
  },
  {
    path: "/statistics/revenue-summary",
    name: "StatisticsRevenueSummary",
    component: StatisticsRevenueSummary
  },
  {
    path: "/statistics/customer-analysis",
    name: "StatisticsCustomerAnalysis",
    component: StatisticsCustomerAnalysis
  },
  {
    path: "/statistics/utilization-table",
    name: "UtilizationTable",
    component: UtilizationTable
  },
  // Finances
  {
    path: "/finances",
    name: "FinancesOverview",
    component: FinancesOverview
  },
  {
    path: "/finances/owner-settlements",
    name: "FinancesOwnerSettlements",
    component: FinancesOwnerSettlements
  },
  {
    path: "/finances/create-invoices",
    name: "CreateFinancesInvoices",
    component: CreateFinancesInvoices
  },
  {
    path: "/finances/invoices",
    name: "FinancesInvoices",
    component: FinancesInvoices
  },
  // Lists
  {
    path: "/lists",
    name: "ListsOverview",
    component: ListsOverview
  },
  {
    path: "/lists/arrivals",
    name: "ListsArrivals",
    component: ListsArrivals
  },
  {
    path: "/lists/departures",
    name: "ListsDepartures",
    component: ListsDepartures
  },
  {
    path: "/lists/cleaners",
    name: "ListsCleaners",
    component: ListsCleaners
  },
  {
    path: "/lists/bookings",
    name: "ListsBookings",
    component: ListsBookings
  },
  {
    path: "/lists/invoices",
    name: "ListsInvoices",
    component: ListsInvoices
  },
  {
    path: "/lists/cleaners",
    name: "ListsCleanersHeatmap",
    component: ListsCleanersHeatmap
  },
  // CMS
  {
    path: "/cms",
    name: "CMSOverview",
    component: CMSOverview
  },
  {
    path: "/cms/medias",
    name: "CMSMedias",
    component: CMSMedias
  },
  {
    path: "/cms/blocks",
    name: "CMSBlocks",
    component: CMSBlocks
  },
  // CMS - Blocks
  {
    path: "/cms/blocks/new/",
    props: true,
    name: "CMSBlockNew",
    component: CMSBlock
  },
  {
    path: "/cms/blocks/edit/:id",
    name: "CMSBlockEdit",
    props: true,
    component: CMSBlock
  },
  //-----------
  {
    path: "/cms/block-models",
    name: "CMSBlockModels",
    component: CMSBlockModels
  },
  // CMS - Block Models
  {
    path: "/cms/block-models/new/",
    props: true,
    name: "CMSBlockModelNew",
    component: CMSBlockModel
  },
  {
    path: "/cms/block-models/edit/:id",
    name: "CMSBlockModelEdit",
    props: true,
    component: CMSBlockModel
  },
  // -----------
  {
    path: "/cms/daily-tips",
    name: "CMSDailyTips",
    component: CMSDailyTips
  },
  {
    path: "/cms/promotions",
    name: "CMSPromotions",
    component: CMSPromotions
  },
  // CMS - Promotion
  {
    path: "/cms/promotions/new/",
    props: true,
    name: "CMSPromotionNew",
    component: CMSPromotion
  },
  {
    path: "/cms/promotions/edit/:id",
    name: "CMSPromotionEdit",
    props: true,
    component: CMSPromotion
  },
  // Data
  {
    path: "/data",
    name: "DataOverview",
    component: DataOverview
  },
  {
    path: "/data/rent-objects/admin-sort",
    name: "DataRentObjectsAdminSort",
    component: DataRentObjectsAdminSort
  },
  {
    path: "/data/rent-objects/channel-manager",
    name: "DataRentObjectChannels",
    component: DataRentObjectChannels
  },
  {
    path: "/data/rent-objects",
    name: "DataRentObjects",
    component: DataRentObjects
  },
  {
    path: "/data/customers",
    name: "DataCustomers",
    component: DataCustomers
  },
  {
    path: "/data/owners",
    name: "DataOwners",
    component: DataOwners
  },
  {
    path: "/data/cleaners",
    name: "DataCleaners",
    component: DataCleaners
  },
  // Data - RentObject
  {
    path: "/data/rent-objects/new",
    props: true,
    name: "DataRentObjectNew",
    component: DataRentObject
  },
  {
    path: "/data/rent-objects/edit/:id",
    name: "DataRentObjectEdit",
    props: true,
    component: DataRentObject
  },
  // Data - Customer
  {
    path: "/data/customers/new",
    props: true,
    name: "DataCustomerNew",
    component: DataCustomer
  },
  {
    path: "/data/customers/edit/:id",
    name: "DataCustomerEdit",
    props: true,
    component: DataCustomer
  },
  // Data - Owner
  {
    path: "/data/owners/new/",
    props: true,
    name: "DataOwnerNew",
    component: DataOwner
  },
  {
    path: "/data/owners/edit/:id",
    name: "DataOwnerEdit",
    props: true,
    component: DataOwner
  },
  // Data - Cleaner
  {
    path: "/data/cleaners/new",
    props: true,
    name: "DataCleanerNew",
    component: DataCleaner
  },
  {
    path: "/data/cleaners/edit/:id",
    name: "DataCleanerEdit",
    props: true,
    component: DataCleaner
  },
];

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
